<div class="card h-100">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="card-title mb-0">Vulnerabilities by Device Type</h5>
    <kendo-dropdownbutton
      kendoButton
      [svgIcon]="moreVerticalIcon"
      fillMode="flat"
      size="small"
      [data]="[{ text: 'View Data' }]"
      (itemClick)="onViewData()"
    ></kendo-dropdownbutton>
  </div>
  <kendo-chart>
    <kendo-chart-series>
      <kendo-chart-series-item
        type="column"
        [data]="deviceTypeChartResponse().data"
        field="vulnerability_count"
        categoryField="device_type"
      >
        <kendo-chart-series-item-tooltip>
          <ng-template
            let-dataItem="dataItem">
            {{ dataItem.vulnerability_count }} vulnerabilities - {{ dataItem.device_count }} devices
          </ng-template>>
        </kendo-chart-series-item-tooltip>
      </kendo-chart-series-item>
    </kendo-chart-series>
    <kendo-chart-category-axis>
      <kendo-chart-category-axis-item field="device_type"></kendo-chart-category-axis-item>
    </kendo-chart-category-axis>
    <kendo-chart-value-axis>
      <kendo-chart-value-axis-item title.text="Number of Vulnerabilities/Devices"></kendo-chart-value-axis-item>
    </kendo-chart-value-axis>
    <kendo-chart-legend position="bottom"></kendo-chart-legend>
  </kendo-chart>
</div>

@if (showPopup()) {
  <kendo-dialog
    (close)="close()"
    [width]="'95vw'"
    [height]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ modalTitle() }}</kendo-dialog-titlebar>

    @if (datatableUrl(); as url) {
      <div class="table-responsive w-100">
        <app-datatable
          [data-href]="url"
          [columns]="datatableColumns"
          [useOData]="true"
          [initialFilters]="periodParams()"
        ></app-datatable>
      </div>
    }
  </kendo-dialog>
}
